import '@/features/afwijkingen/Afwijkingen.less'
import { useTranslation } from 'react-i18next'
import { useCurrentOperatorSkalNumber } from '@/hooks/UseCurrentOperatorSkalNumber'
import { useGetAfwijkingenSupersetTokenLazyQuery } from '@/models'
import { embedDashboard } from '@superset-ui/embedded-sdk'
import { useEffect } from 'react'

function AfwijkingenDashboard (): JSX.Element {
  const { t } = useTranslation()
  const [currentOperatorSkalNumber] = useCurrentOperatorSkalNumber()
  const [getAccessToken, { error }] = useGetAfwijkingenSupersetTokenLazyQuery()

  const fetchGuestTokenFromBackend = async (): Promise<string> => {
    const accessToken = await getAccessToken({
      fetchPolicy: 'no-cache',
      variables: {
        skalNumber: currentOperatorSkalNumber,
        dashboardId: process.env.REACT_APP_AFWIJKINGEN_DASHBOARD_ID ?? ''
      }
    })
    return accessToken.data?.getAfwijkingenSupersetToken?.accessToken ?? ''
  }

  const canLoadDashboard = (): boolean => {
    return typeof error === 'undefined' &&
      currentOperatorSkalNumber !== '' &&
      process.env.REACT_APP_AFWIJKINGEN_DASHBOARD_ID !== null &&
      process.env.REACT_APP_SUPERSET_URI !== null &&
      typeof process.env.REACT_APP_AFWIJKINGEN_DASHBOARD_ID !== 'undefined' &&
      typeof process.env.REACT_APP_SUPERSET_URI !== 'undefined'
  }

  useEffect(() => {
    if (canLoadDashboard()) {
      void embedDashboard({
        id: process.env.REACT_APP_AFWIJKINGEN_DASHBOARD_ID ?? '',
        supersetDomain: process.env.REACT_APP_SUPERSET_URI ?? '',
        mountPoint: document.getElementById('superset-container') as HTMLElement,
        fetchGuestToken: fetchGuestTokenFromBackend,
        dashboardUiConfig: {
          hideTitle: true,
          hideChartControls: true,
          filters: {
            expanded: true
          }
        }
      })
    }
  }, [])

  return (
    <>
      <div className='dashboard-container' data-testid="dashboard">
        <h1>{t('afwijkingen.dashboard.title')}</h1>
      </div>
      <div id='superset-container' />
    </>
  )
}

export default AfwijkingenDashboard
